import { render } from "./appLayout.vue?vue&type=template&id=54d1bafe&scoped=true"
import script from "./appLayout.vue?vue&type=script&lang=js"
export * from "./appLayout.vue?vue&type=script&lang=js"

import "./appLayout.vue?vue&type=style&index=0&id=54d1bafe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54d1bafe"]])

export default __exports__